<template>
  <el-dialog title="批量导入" :visible.sync="dialogVisibleLeadIn" width="900px">
    <div class="main iconLeadIn">
      <div class="header">
        <div
          :class="{'header-item':true,'header-data-upLoad':item.id===1,'header-data-preview':item.id===2,'header-import-data':item.id===3}"
          v-for="(item,index) in stepsList"
          :key="index"
        >
          <div
            :class="activeIndex===item.id||item.id<=activeIndex?'pitch-on':'header-item-number'"
          >{{item.id}}</div>
          <div class="header-item-title">{{item.title}}</div>
          <div
            v-if="item.id!==3"
            :class="item.id<activeIndex?'header-item-lineAfter':'header-item-line'"
          ></div>
        </div>
      </div>
      <div :class="{'content':true,'top-content':activeIndex===1,'bottom-content':activeIndex===3}">
        <div class="upload-files" v-show="activeIndex===1">
          <el-row>
            <el-col :span="2" style="text-align:right;border: 1px solid transparent; ">
              <h4>1.</h4>
            </el-col>
            <el-col :span="22" class="title-content">
              <h4>填写导入数据信息</h4>
              <p class="p-content">请按照数据模版的格式准备导入数据，模版种的表头名称不可更改，表头行不能删除</p>
              <el-button @click="downLoadFile(guid)" plain type="primary">
                <i class="iconfont icon-xiazai" style="font-size:12px;"></i>下载模板
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="text-align:right;border: 1px solid transparent;">
              <h4>2.</h4>
            </el-col>
            <el-col :span="10" class="title-content">
              <h4>上传填好的信息表</h4>
              <el-upload
                ref="upload"
                class="upload-demo"
                :before-upload="beforeUpload"
                :disabled="fileListUp.length !==0"
                :action="actionUrl"
                :on-success="handleSuccess"
                :headers="uploadHeaders"
                :show-file-list="false"
                :file-list="fileList"
              >
                <div
                  slot="tip"
                  style="color:#83878A;"
                  class="el-upload__tip"
                >文件类型必须为Excel（xls或xlsx），大小不得大于10MB；</div>
                <el-button
                  :disabled="fileListUp.length !==0"
                  style="margin-top:10px;margin-bottom:0px;"
                  type="primary"
                >
                  <i class="iconfont icon-shangchuan1" style="font-size:12px;"></i>上传文件
                </el-button>
              </el-upload>
              <el-col :span="24" v-for="(item,index) in fileListUp" :key="index">
                <el-col
                  :span="18"
                  style="margin-top:10px;"
                >{{item.response.obj.guidAndFileName.fileName}}</el-col>
                <el-col :span="3">
                  <i @click="deleteExcel" class="el-icon-close" style="margin-top:15px;"></i>
                </el-col>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="text-align:right">
              <h4>
                <i
                  class="iconfont icon-tishi"
                  style="font-size:14px;color:#D35E5E;padding:2px !important;"
                ></i>
              </h4>
            </el-col>
            <el-col class="specail-suggestion title-content" :span="20">
              <h4 style="color:#D35E5E;">特别提示</h4>
              <!-- 产品导入产品 -->
              <p v-show="guid === this.$store.state.productGuidIn">
                1、导入过程中如发现同品类、品牌、型号、订货号的产品，则不更新这条产品数据；
                <br />2、品类、品牌、系列、产品名称、产品面价、最小单位为必填信息；
                <br />3、型号、订货号必须填写一项；
                <br />4、未填写型号默认与订货号相同，未填写属地默认为未知，未填写是否停产默认为未停产；
                <br />5、产品类型默认为标准产品，如需添加组合产品信息，可在导入成功后，进入产品详情页编辑；
                <br />6、多个型号别称以逗号分隔；
                <br />7、每次最大允许提交5000条数据，若数据过多，请分批提交。
                <br />
              </p>
              <!-- 价格系数 -->
              <p v-show="guid === this.$store.state.productGuidBrand">
                1、导入的数据如匹配成功，将会覆盖原设置，请知晓；
                <br />2、请不要修改品牌名称，品牌名称和系统内如果不同，将无法识别，导入失败；
                <br />3、系列系数单位：%；
                <br />4、导入时仅读取品牌名称、系列系数，如需修改全品类系数请到全品类系数设置页面修改。
                <br />
              </p>
              <!-- 系列系数 -->
              <p v-show="guid === this.$store.state.productGuidSerice">
                1、导入的数据如匹配成功，将会覆盖原数据，请知晓；
                <br />2、请不要修改品牌名称、系列名称，品牌名称和系列名称如果和系统内的数据不匹配，则导入失败；
                <br />3、系列系数单位为百分号（%）：保留小数点后两位；
                <br />4、导入时仅读取品牌名称、系列名称、系列系数，如需修改全品类系数或品牌系数请到全品类系数和品牌系数设置页面修改。
                <br />
              </p>
              <!-- 单品管理 -->
              <p v-show="guid === this.$store.state.productGuidPro">
                1、导入的数据如匹配成功，将会覆盖原数据，请知晓；
                <br />2、请不要修改品牌名称、系列名称、型号名称，如果品牌名称、系列名称、型号名称和系统内的不匹配，则导入失败；
                <br />3、型号系数单位为百分号（%）：小数点后两位有效数字；
                <br />4、导入时仅读取品牌名称、系列名称、型号名称、型号系数，如需修改全品类系数、品牌系数、系列系数请到全品类系数、品牌系数、系列系数设置页面修改。
              </p>
              <!-- 客户-批量导入 -->
              <p v-show="guid === this.$store.state.clientGuidIn">
                1、导入的客户数据如果系统中存在，此次导入会过滤掉这些客户；
                <br />2、客户名称、联系人、联系电话为必填信息；
                <br />3、每次最大允许提交5000条数据，若数据过多，请分批提交。
              </p>
              <!-- 采购-询价导入产品 -->
              <p v-show="guid === this.$store.state.purchaseGuidIn">
                1、请上传要导入的供应商报价信息(供应商名称、单品报价、报价有效期)；
                <br />2、批量导入时相同的一条数据不支持添加多个供应商，如一个供应商无法满足产品需求数量，需添加多个供应商，请通过系统进入详情页处理；
                <br />3、上传报价不支持报价管理更新，如需更新，请通过后台详情页处理
                <br />4、上传报价单时需要通过询价单编号去匹配品类、品牌、系列、产品名称、型号、订货号、类型、货期、数量（导出时的数据），只有完全相同，才可以导入成功；
                <br />5、上传报价单时上传的供应商名称必须存在于系统中，如果不存在，则导入失败；
                <br />6、单品报价，两位有效数字；
                <br />7、报价有效期，格式为yyyy/mm/dd;
                <br />8、明细条目不大于1000条。
              </p>
              <!-- 采购-采购清单采购区导入产品 -->
              <p v-show="guid === this.$store.state.purchasePlanGuidIn">
                1、必填项不可为空；
                <br />2、导入产品备货方式与备货地址不一致，则导入失败；
                <br />3、导入产品数量不可为0
                <br />4、导入的产品如果与待采购清单中产品不匹配，会导入失败；
                <br />5、导入采购区成功的数据将会在待采购区减去相应数量；
                <br />6、导入产品数量大于待采购数量时自动计为待采购数量；
                <br />7、仅支持上传Excel文件，明细条目不大于1000条。
              </p>
              <!-- 生成合同（采购生成）-导入产品 -->
              <p v-show="guid === this.$store.state.productInformationGuid">
                1、必填项不可为空；
                <br />2、型号和订货号都为空；
                <br />3、导入产品数量不可为0
                <br />4、数量格式错误，应为正整数；
                <br />5、货期格式错误，应为正整数；
                <br />6、类型格式错误，应为现货或期货；
              </p>
              <!-- 仓储-货架管理批量新增 -->
              <p v-show="guid === this.$store.state.storgeGuidIn">
                1、请上传要导入的仓库和货架名称；
                <br />2、仓库必须为所选仓库名称；
                <br />3、明细条目不大于1000条；
                <br />4、同一仓库下货架名称不可重复。
              </p>
              <p v-show="guid === this.$store.state.openingInventoryGuid">
                1、必填项不可为空；
                <br />2、型号和订货号必须填写一项；
                <br />3、产品序列号以分号（；）分隔；
                <br />4、仓库必须为所选仓库；
                <br />5、导入的产品品牌如果系统内不存在，会导入失败；
                <br />6、货架必须为所选仓库已存在货架；
                <br />7、导入的数据如果和仓库已存在货架上是相同的产品且采购单价相同，则合并数据；否则，新增产品；
                <br />8、明细条目不大于1000条。
              </p>
              <!--              财务银行对账-->
              <p v-show="guid === this.$store.state.financialAffairsCuidIn">
                1、必填项不可为空；
                <br />2、收款金额正数，保留两位有效数字；
                <br />3、仅支持上传Excel文件，明细条目不大于1000条。
              </p>
              <!--              财务银行对账-->
              <p
                v-show="guid === this.$store.state.financePendingPaymentApplicationBankTransfer || guid === this.$store.state.FfnancePendingPaymentApplicationAcceptanceDraft"
              >
                1、导入的数据需要和系统中已存在的数据完全匹配，如果不匹配，该条数据则导入失败；
                <br />2、当付款结果为付款失败时，需填写失败理由；
                <br />3、仅支持上传Excel文件，明细条目不大于1000条。
              </p>
            </el-col>
          </el-row>
        </div>
        <div class="data-preview" v-show="activeIndex===2">
          <div v-if="!isAbnormal">
            <!-- 产品 产品-批量导入 -->
            <div class="table-content" v-if="guid=== this.$store.state.productGuidIn">
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="productGuidInList"
                :number="395"
                :height="true"
              ></Tablecolumn>
            </div>
            <div class="table-content" v-if="guid=== this.$store.state.productGuidBrand">
              <!-- 品牌价格系数 产品-品牌系数导出导入 -->
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="productGuidBrandList"
                :number="395"
                :height="true"
              >
                <template slot-scope="scope" slot="brandCoefficient">
                  <div class="line-limit-length">{{(scope.row.brandCoefficient*100).toFixed(2)+'%'}}</div>
                </template>
              </Tablecolumn>
            </div>
            <div class="table-content" v-if="guid=== this.$store.state.productGuidSerice">
              <!-- 系列价格系数 产品-系列系数导出导入 -->
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="productGuidSericeList"
                :number="395"
                :height="true"
              >
                <template slot-scope="scope" slot="seriesCoefficient">
                  <div
                    class="line-limit-length"
                  >{{(scope.row.seriesCoefficient*100).toFixed(2)+'%'}}</div>
                </template>
              </Tablecolumn>
            </div>
            <div class="table-content" v-if="guid=== this.$store.state.productGuidPro">
              <!-- 单品价格系数 产品-型号系数导出导入 -->
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="productGuidProList"
                :number="395"
                :height="true"
              >
                <template slot-scope="scope" slot="proCoefficient">
                  <div class="line-limit-length">{{(scope.row.proCoefficient*100).toFixed(2)+'%'}}</div>
                </template>
              </Tablecolumn>
            </div>
            <div class="table-content" v-if="guid=== this.$store.state.clientGuidIn">
              <!-- 客户-批量导入 -->
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="clientGuidInList"
                :number="395"
                :height="true"
              ></Tablecolumn>
            </div>
            <div class="table-content" v-if="guid=== this.$store.state.purchaseGuidIn">
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="purchaseGuidInList"
                :number="395"
                :height="true"
              ></Tablecolumn>
              <!-- 询价的 -->
            </div>
            <!-- 采购清单采购区导入产品 -->
             <div class="table-content" v-if="guid=== this.$store.state.purchasePlanGuidIn">
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="purchasePlanGuidList"
                :number="395"
                :height="true"
              ></Tablecolumn>
            </div>
            <!-- 生成合同（采购生成）-导入产品 -->
             <div class="table-content" v-if="guid=== this.$store.state.productInformationGuid">
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="productInformationGuidList"
                :number="395"
                :height="true"
              ></Tablecolumn>
            </div>
            <div class="table-content" v-if="guid=== this.$store.state.storgeGuidIn">
              <!-- 仓储-货架管理批量新增 -->
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="storgeGuidInList"
                :number="395"
                :height="true"
              ></Tablecolumn>
            </div>
            <div class="table-content" v-if="guid=== this.$store.state.openingInventoryGuid">
              <!-- 仓库-期初库存批量导入 -->
              <Tablecolumn
                :dataList="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                :columnList="openingInventoryGuidList"
                :number="395"
                :height="true"
              ></Tablecolumn>
            </div>

            <div class="table-content" v-if="guid=== this.$store.state.financialAffairsCuidIn">
              <!-- 财务银行对账单导入 -->
              <el-table
                ref="multipleTable"
                :data="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                tooltip-effect="dark"
                max-height="395"
                :header-cell-style="tableHeader"
                border
              >
                <el-table-column show-overflow-tooltip prop="payBankNumber" label="*付款人银行账号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payName" label="*付款人账户名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payOpenBank" label="*付款人开户行名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payBankCode" label="银行行号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiptBankNumber" label="*收款银行账号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiptName" label="*收款人账户名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiptOpenBank" label="*收款人开户行名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="flowCode" label="*交易流水号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="tradeTime" label="*交易日期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="tradeDate" label="*交易时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiptMoney" label="*收款金额"></el-table-column>
              </el-table>
            </div>
            <div
              class="table-content"
              v-if="guid=== this.$store.state.financePendingPaymentApplicationBankTransfer || guid=== this.$store.state.FfnancePendingPaymentApplicationAcceptanceDraft"
            >
              <!-- 财务-待处理付款申请  承兑汇票 -->
              <el-table
                ref="multipleTable"
                v-if="guid === this.$store.state.FfnancePendingPaymentApplicationAcceptanceDraft"
                :data="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                tooltip-effect="dark"
                max-height="395"
                :header-cell-style="tableHeader"
                border
              >
                <el-table-column show-overflow-tooltip prop="payNumber" label="付款编号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payType" label="付款类型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payMethod" label="付款方式"></el-table-column>
                <el-table-column show-overflow-tooltip prop="processState" label="付款状态"></el-table-column>
                <el-table-column show-overflow-tooltip prop="amount" label="付款金额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="billNumber" label="票据号码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="billMoney" label="票据面额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="billCompany" label="出票单位"></el-table-column>
                <el-table-column show-overflow-tooltip prop="billBank" label="出票行"></el-table-column>
                <el-table-column show-overflow-tooltip prop="billDate" label="出票日期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="billEnddate" label="到期日期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="mark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip prop="allAmount" label="申请付款总额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createUser" label="申请人"></el-table-column>
                <el-table-column show-overflow-tooltip prop="orgName" label="所属部门"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createDate" label="申请时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payResult" label="*付款结果"></el-table-column>
                <el-table-column show-overflow-tooltip prop="fileName" label="付款凭证文件名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="loseMark" label="失败理由"></el-table-column>
              </el-table>
              <!-- 财务-待处理付款申请  银行转账 -->
              <el-table
                ref="multipleTable"
                v-else
                :data="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                tooltip-effect="dark"
                max-height="395"
                :header-cell-style="tableHeader"
                border
              >
                <el-table-column show-overflow-tooltip prop="payNumber" label="付款编号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payType" label="付款类型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payMethod" label="付款方式"></el-table-column>
                <el-table-column show-overflow-tooltip prop="processState" label="付款状态"></el-table-column>
                <el-table-column show-overflow-tooltip prop="amount" label="付款金额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiptName" label="账户名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiptBankNumber" label="银行账户"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiptOpenBank" label="开户银行"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiptOpenNumber" label="银行行号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="allAmount" label="申请付款总额"></el-table-column>
                <el-table-column show-overflow-tooltip prop="mark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createUser" label="申请人"></el-table-column>
                <el-table-column show-overflow-tooltip prop="orgName" label="所属部门"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createDate" label="申请时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="payResult" label="*付款结果"></el-table-column>
                <el-table-column show-overflow-tooltip prop="fileName" label="付款凭证文件名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="loseMark" label="失败理由"></el-table-column>
              </el-table>
            </div>

            <!-- 分页器 -->
            <div class="lpagination">
              <el-pagination
                align="center"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[30]"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="uploadTable.length"
              ></el-pagination>
            </div>
          </div>

          <div v-if="isAbnormal">
            <el-row style="border-bottom:1px solid #DCDDDE;padding:10px 0;">
              <el-col :span="22" style="padding-left:30px;padding-bottom:10px;">
                <i class="el-icon-warning-outline" style="color:$btnDanger"></i>
                <span style="padding-left:5px;">
                  异常数据：
                  <span style="color:#D35E5E;">{{normalMap.abnormal}}条</span>
                </span>
                <span style="padding-left:20px;">
                  正常数据：
                  <span style="color:#61CA6E">{{normalMap.normal}}条</span>
                </span>
              </el-col>
            </el-row>
            <el-row style="padding-left:30px;max-height:400px;overflow-y:auto;">
              <el-col :span="24">
                <h4>异常提醒：</h4>
              </el-col>
              <el-col
                :span="24"
                v-for="(item,index) in abnormalListVo"
                :key="index"
                style="font-size:13px;padding-bottom:10px;"
              >{{item}}</el-col>
            </el-row>
          </div>
        </div>
        <div class="import-data" v-show="activeIndex===3">
          <div style="text-align:center;margin-top:50px;">
            <i class="el-icon-success"></i>
            <h4>上传成功</h4>

            <div style="color:#83878A;">
              您已成功导入
              <span>{{count}}</span>条数据
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" style="padding-top:10px;">
      <el-button type="primary" @click="onNext" v-if="activeIndex!==stepsList.length">下一步</el-button>
      <el-button type="primary" @click="onLast" v-if="activeIndex===2" plain>重新上传</el-button>
      <el-button v-else @click="dialogVisibleLeadIn = false">取 消</el-button>
    </div>
    <loading></loading>
  </el-dialog>
</template>
<script>
import { stepsList } from './utils/data'
import { uploadDownExcel } from '@/util/tool'

import loading from '@/components/Loading'
import { querySystemAttachmentAddressVo } from '@/api/purchase/purchaseManage'
import { getToken } from '@/util/auth' // get token from cookie
import {
  addImportProduct,
  addImportBrandCoefficient,
  addByUpload,
  addImportBrandSeries,
  addImportProductModel,
  addImportEnquiry,
  StockAffirm,
  addImportShelvesConfirm,
  addShelvesProductAffirm,
  addBankReceiptImport, addImportFinancePay, contractContentAffirm
} from '@/api/product/productManage'
import {
  productGuidInList,
  productGuidBrandList,
  clientGuidInList,
  productGuidProList,
  productGuidSericeList,
  purchaseGuidInList,
  openingInventoryGuidList,
  storgeGuidInList,
  purchasePlanGuidList,
  productInformationGuidList
} from './data'
import Tablecolumn from '@/components/tableColumn/index'

export default {
  name: 'leadIn',
  components: {
    Tablecolumn, loading
  },
  data () {
    return {
      fileListUp: [],
      fileList: [],
      isMax: false, // 删除图片时 恢复显示
      count: 0,
      productInformationGuidList: productInformationGuidList, // 生成合同（采购生成）
      productGuidInList: productGuidInList,
      productGuidBrandList: productGuidBrandList,
      clientGuidInList: clientGuidInList,
      productGuidProList: productGuidProList,
      productGuidSericeList: productGuidSericeList,
      purchaseGuidInList: purchaseGuidInList,
      purchasePlanGuidList: purchasePlanGuidList, // 采购清单
      openingInventoryGuidList: openingInventoryGuidList,
      storgeGuidInList: storgeGuidInList,
      guid: '',
      name: '',
      currentPage: 1,
      pageSize: 30,
      isAbnormal: false,
      dialogVisibleLeadIn: false,
      stepsList: [],
      uploadTable: [],
      activeIndex: 1,
      uploadHeaders: {},
      normalMap: {},
      actionUrl: '',
      quoteTable: [], // 异常数据
      sbId: ''
    }
  },
  created () {
    this.uploadHeaders = {
      Authorization: ` Bearer ${getToken()}`
    }
    this.stepsList = stepsList
  },

  methods: {
    beforeUpload (file) {
      // 显示loading
      this.bus.$emit('loading', true)
      // 判断图片的类型
    },
    deleteExcel () {
      this.fileListUp = []
      this.fileList = []
    },
    // 上传成功
    handleSuccess (response, file, fileList) {
      if (response.code === 200) {
        // 关闭loading
        this.bus.$emit('loading', false)

        this.fileList = [] // 上传成功进行隐藏
        if (response.obj.abnormalListVo.abnormalList.length !== 0) {
          // 导入数据有异常
          this.abnormalListVo = response.obj.abnormalListVo.abnormalList
          this.normalMap = response.obj.abnormalListVo.normalMap
          this.isAbnormal = true
        } else {
          // 导入数据无异常
          this.uploadTable = response.obj.excelList
          this.isAbnormal = false
        }
        this.importDataParams = response.obj

        this.fileListUp = fileList // 用来判断是否上传excel
      } else {
        // 关闭loading
        this.bus.$emit('loading', false)
        this.$message.error(response.msg)
        this.fileList = []
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },

    downLoadFile (guid) {
      querySystemAttachmentAddressVo(guid).then((res) => {
        if (res.data.code === 200) {
          uploadDownExcel(
            this.$store.state.https + res.data.obj.filePath,
            this.name
          )
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onLeadIn (guidExcel, nameExcel, sbId) {
      this.sbId = sbId
      this.fileList = []
      this.fileListUp = []
      this.guid = guidExcel
      this.name = nameExcel
      this.activeIndex = 1
      if (this.guid === this.$store.state.productGuidIn) {
        this.actionUrl = '/api/productBase/queryPreview' // 产品导入√
      } else if (this.guid === this.$store.state.productGuidBrand) {
        this.actionUrl = '/api/brandBase/brandBasePreview' // 产品品牌√
      } else if (this.guid === this.$store.state.productGuidSerice) {
        this.actionUrl = '/api/brandSeries/brandSeriesPreview' // 产品系列√
      } else if (this.guid === this.$store.state.productGuidPro) {
        this.actionUrl = '/api/productBase/queryProModelPreview' // 产品单品
      } else if (this.guid === this.$store.state.clientGuidIn) {
        this.actionUrl = '/api/customerBase/queryByExcel' // 客户批量导入√
      } else if (this.guid === this.$store.state.purchaseGuidIn) {
        this.actionUrl = '/api/orderManualInquiry/orderEnquiryPreview' // 采购询价预览
      } else if (this.guid === this.$store.state.purchasePlanGuidIn) {
        this.actionUrl = '/api/orderContractStockupPurchase/StockPreview' // 采购清单-导入产品
      } else if (this.guid === this.$store.state.productInformationGuid) {
        this.actionUrl = '/api/purchaseContractContent/contractContentPreview' // 生成合同（采购生成）-导入产品
      } else if (this.guid === this.$store.state.storgeGuidIn) {
        this.actionUrl = `/api/storageShelves/storageShelvesPreview/${this.sbId}` // 仓储-货架管理批量新增
      } else if (this.guid === this.$store.state.openingInventoryGuid) {
        this.actionUrl = `/api/storageShelvesProduct/shelvesProductPreview/${this.sbId}`
      } else if (this.guid === this.$store.state.financialAffairsCuidIn) {
        this.actionUrl = '/api/finaceBankReceipt/bankReceiptPreview'
      } else if (this.guid === this.$store.state.FfnancePendingPaymentApplicationAcceptanceDraft || this.guid === this.$store.state.financePendingPaymentApplicationBankTransfer) {
        this.actionUrl = '/api/financePayRequestSource/queryFinancePayPreview'
      }
      this.dialogVisibleLeadIn = true
    },
    // 下一步
    onNext () {
      if (this.activeIndex === 1) {
        if (this.fileListUp.length === 0) {
          this.$message.error('未上传数据文件')
        } else {
          this.activeIndex += 1
          this.$refs.upload.submit()
        }
      } else if (this.activeIndex === 2) {
        // 显示loading
        this.bus.$emit('loading', true)
        // 导入数据操作
        if (this.guid === this.$store.state.productGuidIn) {
          // 导入数据
          addImportProduct(this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj
                this.$emit('onRefresh')
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.productGuidBrand) {
          // 品牌
          addImportBrandCoefficient(this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj
                this.$emit('onRefresh')
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.productGuidSerice) {
          // 系列
          addImportBrandSeries(this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj
                this.$emit('onRefresh')
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.productGuidPro) {
          // 单品
          addImportProductModel(this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj
                this.$emit('onRefresh')
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.clientGuidIn) {
          if (this.$route.path === '/crm/customer/myCustomer') {
            // 客户-批量导入
            addByUpload(0, this.importDataParams)
              .then((res) => {
                if (res.data.code === 200) {
                  // 关闭loading
                  this.bus.$emit('loading', false)
                  this.activeIndex += 1
                  this.count = res.data.obj
                  this.$emit('onRefresh')
                  setTimeout(() => {
                    this.dialogVisibleLeadIn = false
                  }, 3000)
                } else {
                  // 关闭loading
                  this.bus.$emit('loading', false)
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => {
                console.log(err)
              })
          } else {
            // 客户-批量导入
            addByUpload(1, this.importDataParams)
              .then((res) => {
                if (res.data.code === 200) {
                  // 关闭loading
                  this.bus.$emit('loading', false)
                  this.activeIndex += 1
                  this.count = res.data.obj
                  this.$emit('onRefresh')
                  setTimeout(() => {
                    this.dialogVisibleLeadIn = false
                  }, 3000)
                } else {
                  // 关闭loading
                  this.bus.$emit('loading', false)
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => {
                console.log(err)
              })
          }
        } else if (this.guid === this.$store.state.purchaseGuidIn) {
          // 询价的
          addImportEnquiry(this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj
                this.$emit('onRefresh')
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.purchasePlanGuidIn) {
          // 采购清单采购区导入产品
          StockAffirm(this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj.count
                this.$emit('onRefresh', res.data.obj.purchaseListVos)
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.productInformationGuid) {
          // 生成合同（采购生成）-导入产品
          contractContentAffirm(this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj.count
                this.$emit('onRefresh', res.data.obj.contractContentVOList)
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.storgeGuidIn) {
          // 仓储货架
          addImportShelvesConfirm(this.sbId, this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj
                this.$emit('onRefresh', this.sbId)
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.openingInventoryGuid) {
          // 仓储货架
          addShelvesProductAffirm(this.sbId, this.importDataParams)
            .then((res) => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj.successCount
                if (res.data.obj.successCount === 0) {
                  this.$emit('onRefresh', this.sbId, [])
                } else {
                  this.$emit('onRefresh', this.sbId, res.data.obj.storageShelvesInitsVoList)
                }
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                this.bus.$emit('loading', false)
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.guid === this.$store.state.financialAffairsCuidIn) {
          // 财务银行对账
          addBankReceiptImport(this.importDataParams)
            .then(res => {
              if (res.data.code === 200) {
                // 关闭loading
                this.bus.$emit('loading', false)
                this.activeIndex += 1
                this.count = res.data.obj
                if (res.data.obj.successCount === 0) {
                  this.$emit('onRefresh', [])
                } else {
                  this.$emit('onRefresh', res.data.obj.storageShelvesInitsVoList)
                }
                setTimeout(() => {
                  this.dialogVisibleLeadIn = false
                }, 3000)
              } else {
                this.bus.$emit('loading', false)

                this.$message.error(res.data.msg)
              }
            })
        } else if (this.guid === this.$store.state.FfnancePendingPaymentApplicationAcceptanceDraft || this.guid === this.$store.state.financePendingPaymentApplicationBankTransfer) {
          // 财务-待处理付款申请
          addImportFinancePay(this.importDataParams).then(res => {
            if (res.data.code === 200) {
              // 关闭loading
              this.bus.$emit('loading', false)
              this.activeIndex += 1
              this.count = res.data.obj
              if (res.data.obj === 0) {
                this.$emit('onRefresh', [])
              } else {
                this.$emit('onRefresh', res.data.obj.storageShelvesInitsVoList)
              }
              setTimeout(() => {
                this.dialogVisibleLeadIn = false
              }, 3000)
            } else {
              this.bus.$emit('loading', false)

              this.$message.error(res.data.msg)
            }
          })
        }
      }
    },
    // 重新上传
    onLast () {
      this.activeIndex -= 1
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }

  }
}
</script>
<style lang="scss" scoped>
.p-content {
  color: #83878a;
  font-size: 12px;
  margin: 5px 0 7px !important;
}
.title-content {
  padding-left: 1px;
}
.lpagination {
  display: flex;
  justify-content: flex-end;
  // text-algin:right;
  width: 100%;
  padding: 0px 0px 20px;
}
.table-content {
  height: 405px;
}
.main {
  height: 480px;
  .header {
    display: flex;
    justify-content: space-between;
    width: 70%;
    margin: auto;
    .header-data-upLoad {
      width: 45%;
    }
    .header-data-preview {
      width: 45%;
    }
    .header-import-data {
      width: 20%;
    }
    .header-item {
      display: flex;
      text-align: center;
      .header-item-line {
        background-color: #ced1d7;
        width: 120px;
        height: 1px;
        margin-top: 15px;
        margin-left: 13px;
        text-align: center;
      }
      .pitch-on {
        height: 30px;
        width: 30px;
        line-height: 30px;
        background: #276cff !important;
        color: #fff;
        border-radius: 30px;
      }
      .header-item-lineAfter {
        background-color: #276cff;
        width: 120px;
        height: 1px;
        margin-top: 15px;
        margin-left: 13px;
        text-align: center;
      }
      .header-item-number {
        height: 30px;
        width: 30px;
        line-height: 30px;
        border: 1px solid #cdd1d7;
        color: #cdd1d7;
        border-radius: 30px;
      }
      .header-item-title {
        line-height: 30px;
        padding-left: 10px;
        font-size: 15px;
      }
    }
  }
  .bottom-content {
    padding-top: 70px;
  }
  .top-content {
    padding-top: 20px;
  }
  .content {
    h4 {
      font-size: 14px;
    }
    .specail-suggestion {
      p {
        color: #83878a;
        font-size: 12px;
        margin: 5px 0 1px !important;
      }
    }

    .upload-files {
      .el-row {
        margin-top: 30px;
      }
      .el-icon-folder-add,
      .el-icon-folder-checked,
      .el-icon-warning-outline {
        font-size: 33px;
      }
      h4 {
        margin: 0px !important;
      }
    }
    .data-preview,
    .import-data {
      margin-top: 30px;
      .el-icon-success {
        font-size: 60px;
        color: #61ca6e;
      }
    }
  }
}
.footer {
  margin-top: 30px;
  text-align: right;
}
</style>
